import { useState } from 'react';
import { Box, Paper, styled, Tab, Tabs } from '@mui/material';
import {
  CustomTabPanel,
  a11yProps,
} from '../../../components/Tabs/accordionAndTabPanel';
import ProgramaAtual from './ProgramaAtual';
import MercadoAlvoCrm from './MercadoAlvo';
import Anexo from './Anexo';
import PPC from './Perfil';
import { useTranslation } from '../../../commons/useTranslasion';
import { ptBR, esES } from '@mui/material/locale';

const AssessoradoDetalhes: React.FC = () => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const [value, setValue] = useState<number>(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <DivDetalhes>
      <PaperDetalhes style={{ paddingBottom: '60px' }}>
        <Box sx={{ width: '100%' }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              padding: '0px 25px !important',
            }}
          >
            <Tabs
              value={value}
              onChange={handleChangeTab}
              aria-label="tabs assessorado detalhes"
            >
              <Tab label={translate("programaAtual")} {...a11yProps(0)} />
              <Tab label={translate("mercadoAlvo")} {...a11yProps(1)} />
              <Tab label={translate("perfil")} {...a11yProps(2)} />
              <Tab label={translate("anexo")} {...a11yProps(3)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <ProgramaAtual />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <MercadoAlvoCrm />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <PPC></PPC>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Anexo />
          </CustomTabPanel>
        </Box>
      </PaperDetalhes>
    </DivDetalhes>
  );
};

export const DivDetalhes = styled(Box)`
  padding: 20px;
  width: 100%;
  overflow: hidden;
`;

export const PaperDetalhes = styled(Paper)`
  padding: 30px;
`;

export default AssessoradoDetalhes;
